import type { FC } from 'react';

export const AddIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66667 4H5.33333M4 2.66667V5.33333M7 4C7 5.65687 5.65687 7 4 7C2.34315 7 1 5.65687 1 4C1 2.34315 2.34315 1 4 1C5.65687 1 7 2.34315 7 4Z"
      stroke={props.color || 'white'}
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
